// Détection du domaine d'entrée — identité par domaine (marque Mboa Go vs Nold Go).
export function currentHost() {
  if (typeof window === "undefined") return "";
  return (window.location.hostname || "").toLowerCase();
}

// Vrai si l'utilisateur arrive via noldgo.com (ou un sous-domaine) → version Europe « Nold Go ».
export function isNoldDomain() {
  return /(^|\.)noldgo\./i.test(currentHost());
}

// Vrai si l'utilisateur arrive via bentskingo.com → marque Mboa Go (comportement historique conservé).
export function isBentskinDomain() {
  return /(^|\.)bentskingo\./i.test(currentHost());
}
